import { Button, Stack } from "@mui/material";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const ErrorAppAccessPage: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={t(Resources.Errors.ErrorAppAccess.Title)}>
      <EmptyPage
        title={t(Resources.Errors.ErrorAppAccess.Title)}
        subtitle={t(Resources.Errors.ErrorAppAccess.Subtitle)}
        actions={
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={Spacing.L} mt={Spacing.XXL}>
            <Button onClick={() => signOut()}>{t(Resources.Errors.ErrorAppAccess.Button)}</Button>
          </Stack>
        }
      />
    </UnauthenticatedLayout>
  );
};
